module.exports = __webpack_public_path__ + "static/media/logo-wealthpoint.f8e4fe17.svg";